import { create } from 'zustand'

interface BonusSystemStore {
    isClosingModalsRequested: boolean
    setIsClosingModalsRequested: (requested: boolean) => void
    areModalsClosed: boolean
    setAreModalsClosed: (closed: boolean) => void
    isBonusesPopupPending: boolean
    setIsBonusesPopupPending: (pending: boolean) => void
}

export const useBonusSystemStore = create<BonusSystemStore>((set) => ({
    isClosingModalsRequested: false,
    setIsClosingModalsRequested: (requested) => set({ isClosingModalsRequested: requested }),
    areModalsClosed: false,
    setAreModalsClosed: (closed) => set({ areModalsClosed: closed }),
    isBonusesPopupPending: false,
    setIsBonusesPopupPending: (pending) => set({ isBonusesPopupPending: pending }),
}))
